import React from 'react';

export default function Hero() {
  return (
    <section id="hero" className="hero">
      <div className="hero-bg" />
      <div className="hero-grid" />
      <div className="hero-content">
        <div className="hero-badge">● Now Available for Events &amp; Hire</div>

        <img
          src="/images/rushputt_logo.png"
          alt="RushPutt"
          className="hero-logo-img"
        />

        <p className="hero-sub">Interactive Putting Game</p>
        <p className="hero-desc">
          The ultimate competitive putting experience for corporate events, parties,
          golf days, and venues. Fully scored, LED-lit, and unforgettable.
        </p>
        <div className="hero-btns">
          <a href="#callback" className="btn-primary">Request a Quote</a>
          <a href="#callback" className="btn-outline">Request a Callback</a>
          <a href="#reviews" className="btn-outline">Customer Reviews</a>
        </div>
      </div>
      <div className="hero-scroll">
        <div className="scroll-line" />
        Scroll
      </div>
    </section>
  );
}
